module.exports = __webpack_public_path__ + "static/media/social-twitter.942c6d2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-twitter.svg
// module id = 93
// module chunks = 0